/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listBlobs.defs.js'
export * as $defs from './listBlobs.defs.js'
